// extracted by mini-css-extract-plugin
export default {"map":"components-settings-my-hotel-card-address-module__map","country-select--error":"components-settings-my-hotel-card-address-module__country-select--error"};